/* Drippy PDP v2 · Instagram-style pinch zoom on phone gallery photos (Johannes 2026-10-10).
   Two fingers on a gallery photo lift it above the page; it scales and follows the fingers.
   Let go and it springs back into place. One finger still swipes the gallery as before.
   Photos only (videos are skipped). Phones and tablets only (< 990px). */
(function () {
  if (window.__drippyPinch) return;
  window.__drippyPinch = true;

  var MQ = window.matchMedia('(max-width: 989px)');
  var GALLERY = '.js-media-mobile-list, .js-media-list';
  var MAX = 4;
  var s = null; // active pinch state

  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function mid(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

  function bestSrc(img) {
    // Largest srcset candidate, so the zoomed photo stays sharp.
    var set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    var best = img.currentSrc || img.src, bw = 0;
    set.split(',').forEach(function (part) {
      var p = part.trim().split(/\s+/), w = parseInt(p[1], 10);
      if (p[0] && w > bw) { bw = w; best = p[0]; }
    });
    return best;
  }

  function swiperOf(img) {
    var el = img.closest('.swiper');
    return el && el.swiper ? el.swiper : null;
  }

  function start(e, img) {
    var r = img.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var t0 = e.touches[0], t1 = e.touches[1], m = mid(t0, t1);

    var shade = document.createElement('div');
    shade.className = 'v2-pinch-shade';
    var clone = new Image();
    clone.className = 'v2-pinch-img';
    clone.alt = '';
    clone.src = img.currentSrc || img.src;
    clone.style.left = r.left + 'px';
    clone.style.top = r.top + 'px';
    clone.style.width = r.width + 'px';
    clone.style.height = r.height + 'px';
    clone.style.objectFit = getComputedStyle(img).objectFit || 'cover';
    clone.style.transformOrigin = (m.x - r.left) + 'px ' + (m.y - r.top) + 'px';
    document.body.appendChild(shade);
    document.body.appendChild(clone);

    var hi = bestSrc(img);
    if (hi && hi !== clone.src) { var pre = new Image(); pre.onload = function () { if (s && s.clone === clone) clone.src = hi; }; pre.src = hi; }

    img.style.visibility = 'hidden';
    var sw = swiperOf(img);
    if (sw) sw.allowTouchMove = false;

    s = { img: img, clone: clone, shade: shade, d0: dist(t0, t1), m0: m, scale: 1, sw: sw };
  }

  function move(e) {
    var t0 = e.touches[0], t1 = e.touches[1];
    var sc = Math.min(MAX, Math.max(1, dist(t0, t1) / s.d0));
    var m = mid(t0, t1);
    s.scale = sc;
    s.clone.style.transform = 'translate3d(' + (m.x - s.m0.x) + 'px,' + (m.y - s.m0.y) + 'px,0) scale(' + sc + ')';
    s.shade.style.opacity = String(Math.min(0.85, (sc - 1) * 0.9));
  }

  function end() {
    var st = s; s = null;
    st.clone.classList.add('is-back');
    st.shade.classList.add('is-back');
    st.clone.style.transform = 'translate3d(0,0,0) scale(1)';
    st.shade.style.opacity = '0';
    var done = false;
    function finish() {
      if (done) return; done = true;
      st.img.style.visibility = '';
      st.clone.remove(); st.shade.remove();
      if (st.sw) st.sw.allowTouchMove = true;
    }
    st.clone.addEventListener('transitionend', finish);
    setTimeout(finish, 400);
  }

  document.addEventListener('touchstart', function (e) {
    if (!MQ.matches || s || e.touches.length !== 2) return;
    var a = e.touches[0].target, b = e.touches[1].target;
    if (!(a.closest && a.closest(GALLERY))) return;
    var slide = a.closest('.swiper-slide, li');
    var img = a.tagName === 'IMG' ? a : (slide && slide.querySelector('img'));
    if (!img || (slide && slide.querySelector('video, deferred-media, iframe'))) return;
    if (!(b.closest && b.closest(GALLERY))) return;
    e.preventDefault();
    e.stopPropagation();
    start(e, img);
  }, { capture: true, passive: false });

  document.addEventListener('touchmove', function (e) {
    if (!s) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.touches.length >= 2) move(e);
  }, { capture: true, passive: false });

  function release(e) { if (s && e.touches.length < 2) end(); }
  document.addEventListener('touchend', release, { capture: true });
  document.addEventListener('touchcancel', release, { capture: true });

  var css = document.createElement('style');
  css.textContent =
    '.v2-pinch-shade{position:fixed;inset:0;background:#000;opacity:0;z-index:2147483000;pointer-events:none}' +
    '.v2-pinch-shade.is-back{transition:opacity .28s ease}' +
    '.v2-pinch-img{position:fixed;z-index:2147483001;pointer-events:none;will-change:transform;margin:0;max-width:none}' +
    '.v2-pinch-img.is-back{transition:transform .28s cubic-bezier(.2,.8,.2,1)}' +
    '@media (max-width:989px){.pdp-v2 .js-media-mobile-list img,.pdp-v2 .js-media-list img{touch-action:pan-x pan-y}}' +
    '@media (prefers-reduced-motion:reduce){.v2-pinch-img.is-back,.v2-pinch-shade.is-back{transition:none}}';
  document.head.appendChild(css);
})();
